import qs from 'qs';
import { QUERY_KEYS_TO_REMOVE_ON_ACCOUNT_POPUP_CLOSE } from 'utils/constants/account/url-sections-query-keys';
import { updateQuery } from 'components/QueryRoute';

export const prepareLocationForAccountClose = (location: string) => {
  const [_location, _search] = location.split('?');
  const queriesToRemove = QUERY_KEYS_TO_REMOVE_ON_ACCOUNT_POPUP_CLOSE.reduce(
    (acc, current) => {
      acc[current] = undefined;

      return acc;
    },
    {} as Record<string, string | undefined>
  );

  const allQueries = qs.parse(_search, { ignoreQueryPrefix: true });

  return updateQuery(
    { ...allQueries, ...queriesToRemove },
    '',
    undefined,
    false,
    _location
  );
};
